// What are Blocks
// Blocks are defined in Backend for using in CMS

import {
  Accessories,
  AccessoryDetails,
  AccessoryList,
  AccessoryPackDetails,
  AccordionGroup,
  CompareTool,
  Configurator,
  FeatureYouTube,
  Footer,
  Gallery,
  GalleryFullWidth,
  GalleryItem,
  IconToutBlock,
  ImageToutBlock,
  MyMazdaLogin,
  MyMazdaSpecificationBlock,
  MyMazdaSummary,
  OutletStoreSpecificationsBlock,
  Overlay,
  PostcodePopup,
  ScrapedPage,
  ServiceCalculatorOwner,
  ServiceCalculatorProspect,
  SocialIcons,
  TriggeredOverlay
} from "containers" // eslint-disable-line import/no-duplicates

import {
  Hyperlink,
  NameplateLink as FlexIconLink,
  VideoSlideshow,
} from "components" // @CMS-CHANGE FlexIconLink => NameplateLink

// Import blocks without name-change
import CountdownTimer from "./countdown-timer"
import DynamicTextVideoFrameBlock from "./dynamic-text-video-frame"
import FullWidthMultiVideoBlock from "./full-width-multi-video"
import GlobalNavItemGridBlock from "./global-nav-item-grid"
import GyroscopeBlock from "./gyroscope"
import HeadingSectionBlock from "./heading-section"
import HeroVideoWithTimedFrames from "./hero-video-with-timed-frames"
import MapSearchBlock from "./map-search"
import MapSelectStateBlock from "./map-select-state"
import SingleDealerMapBlock from "./single-dealer-map"
import TimeClockVideoFrameBlock from "./time-clock-video-frame"

// MyMazda
import MyMazda from "./mymazda"
import MyMazdaManageAccountBlock from "./mymazda/manage-account"
import MyMazdaAccountPassword from "./mymazda/account-password"
import MyMazdaCreateAccount from "./mymazda/create-account"
import MyMazdaDealerBlock from "./mymazda/dealer-block"
import MyMazdaDynamicResource from "./mymazda/dynamic-resource"
import MyMazdaDynamicResourceItem from "./mymazda/dynamic-resource/item"
import MyMazdaFullSpecBlock from "./mymazda/vehicle-specs"
import MyMazdaManageVehiclesBlock from "./mymazda/manage-vehicles"
import MyMazdaNotifications from "./mymazda/notifications"
import MyMazdaPolicies from "./mymazda/policies"
import MyMazdaPolicyDetail from "./mymazda/policies/detail"
import MyMazdaPolicyItem from "./mymazda/policies/item"
import MyMazdaPolicySummary from "./mymazda/policies/summary"
import MyMazdaRecallNotification from "./mymazda/recall-notification"
import MyMazdaRegistration from "./mymazda/registration"
import MyMazdaResetPassword from "./mymazda/reset-password"
import MyMazdaServiceHistoryExport from "./mymazda/service/export"
import MyMazdaServiceRequestFormBlock from "./mymazda/service/form"
import MyMazdaServiceSummaryBlock from "./mymazda/service/summary"
import MyMazdaUnauthRedirectBlock from "./mymazda/redirect"
import MyMazdaVehicleResourceList from "./mymazda/vehicle-resource-list"
import MyMazdaVehicleServiceCarouselBlock from "./mymazda/service/carousel"
import MyMazdaVehicleServiceHistoryBlock from "./mymazda/service/history"
import MyMazdaConfirmChangeEmailBlock from "./mymazda/confirm-change-email"

// Import blocks with name-change (@TODO: Change these names in CMS)
import CompareVehicleSelector from "./compare-vehicle-selector" // @CMS-CHANGE CompareVehicleSelector => CompareVehicleSelectorBlock
import FullWidthImageSection from "./full-width-image-section" // @CMS-CHANGE FullWidthImageSection => FullWidthImageSectionBlock
import GlobalNav from "./global-nav" // @CMS-CHANGE GlobalNav => GlobalNavBlock
import InteractiveSlideshowBlock from "./text-media-slider" // @CMS-CHANGE InteractiveSlideshowBlock => TextMediaSliderBlock
import NavDropdown from "./global-nav-dropdown" // @CMS-CHANGE NavDropdown => GlobalNavDropdownBlock
import Offers from "./offers" // @CMS-CHANGE Offers => OffersBlock
import OutletDetail from "./outlet-store-detail" // @CMS-CHANGE OutletDetail => OutletStoreDetailBlock
import ServiceDetailsFull from "./service-details-full" // @CMS-CHANGE ServiceDetailsFull => ServiceDetailsFullBlock
import SiteSearchBlock from "./site-search"
import ToutBlock from "./tout-block" // @CMS-CHANGE what is it really?
import {
  HeadingBlock as Heading
} from "containers" // eslint-disable-line import/first, import/no-duplicates
import DealerMapPage from "./dealer-map-page" // @CMS-CHANGE FlexContent => GlobalNavItemGridBlock


// Atomic Design
import RecallsBlock from "./RecallsBlock"
import WysiwygContent from "./WysiwygContent"
import Column from "./Column"

const FlexContent = GlobalNavItemGridBlock


// Export All
export {
  Accessories,
  AccessoryDetails,
  AccessoryList,
  AccessoryPackDetails,
  AccordionGroup,
  CompareTool,
  CompareVehicleSelector,
  Configurator,
  CountdownTimer,
  DealerMapPage,
  DynamicTextVideoFrameBlock,
  FeatureYouTube,
  FlexContent,
  FlexIconLink,
  Footer,
  FullWidthImageSection,
  FullWidthMultiVideoBlock,
  Gallery,
  GalleryFullWidth,
  GalleryItem,
  GlobalNav,
  GlobalNavItemGridBlock,
  GyroscopeBlock,
  Heading,
  HeadingSectionBlock,
  HeroVideoWithTimedFrames,
  Hyperlink,
  IconToutBlock,
  ImageToutBlock,
  InteractiveSlideshowBlock,
  MapSearchBlock,
  MapSelectStateBlock,
  NavDropdown,
  Offers,
  OutletDetail,
  OutletStoreSpecificationsBlock,
  Overlay,
  PostcodePopup,
  ScrapedPage,
  ServiceCalculatorOwner,
  ServiceCalculatorProspect,
  ServiceDetailsFull,
  SingleDealerMapBlock,
  SiteSearchBlock,
  SocialIcons,
  TimeClockVideoFrameBlock,
  ToutBlock,
  TriggeredOverlay,
  VideoSlideshow
}

// MyMazda
export {
  MyMazda,
  MyMazdaManageAccountBlock,
  MyMazdaAccountPassword,
  MyMazdaCreateAccount,
  MyMazdaDealerBlock,
  MyMazdaDynamicResource,
  MyMazdaDynamicResourceItem,
  MyMazdaFullSpecBlock,
  MyMazdaLogin,
  MyMazdaManageVehiclesBlock,
  MyMazdaNotifications,
  MyMazdaPolicies,
  MyMazdaPolicyDetail,
  MyMazdaPolicyItem,
  MyMazdaPolicySummary,
  MyMazdaRecallNotification,
  MyMazdaRegistration,
  MyMazdaResetPassword,
  MyMazdaServiceHistoryExport,
  MyMazdaServiceRequestFormBlock,
  MyMazdaServiceSummaryBlock,
  MyMazdaSpecificationBlock,
  MyMazdaSummary,
  MyMazdaUnauthRedirectBlock,
  MyMazdaVehicleResourceList,
  MyMazdaVehicleServiceCarouselBlock,
  MyMazdaVehicleServiceHistoryBlock,
  MyMazdaConfirmChangeEmailBlock
}

// Atomic Design
export {
  CardYoutubePlayerList,
  ContentCardList,
  RecallDocument,
  PDFTemplate,
  SixtyFourtyBlock,
  FiftyFiftyBlock,
  Button,
  GradePicker,
  SpecificationsBlock
}
from "AtomicContainers"

export {
  ColumnGroup
}
from "AtomicComponents"

export {
  RecallsBlock,
  WysiwygContent,
  Column
}



// WEBPACK FOOTER //
// ./src/blocks/index.js